import { Component, EventEmitter, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PageEvent } from '@angular/material/paginator';
import { DataService } from 'src/app/services/data.service';
import {AirConfigService}  from 'src/app/services/air-config.service'
import {AirManagementService}  from 'src/app/services/air-management.service'

import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl, RequiredValidator } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import { Router ,ActivatedRoute} from '@angular/router';
import { SettingsService } from 'src/app/services/settings.service';
@Component({
  selector: 'app-fares-rules-config',
  templateUrl: './fares-rules-config.component.html',
  styleUrls: ['./fares-rules-config.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class FaresRulesConfigComponent {
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);

  columnsDisplay: string[] = ['carrier','source','priority','type','class','fareType','basis','flight'];
  faredata:any
  expandedElement!: any | null;
  totalElements:any=0
  addfare:any={
    boolean:false,
  action:''}
  action:any
  fareRegFg:FormGroup
  carrierList:any=[]
searchText:any=''
disabled:boolean=false
id:any
  constructor(private DataService:DataService,private route :ActivatedRoute,private SettingsService:SettingsService,
    private AirConfigService:AirConfigService,private fb : FormBuilder,    private toastMsgService : ToastmsgService,private AirManagementService:AirManagementService){
     
    this.DataService.portMessage.subscribe((item:any)=>{
      this.addfare=item
      this.changeRule=[]
      this.scheduleData= [];
    })
    this.route.queryParams.subscribe(params => {
      let data:any
      data=params
      if(data.id){
      this.id=this.SettingsService.decodeTransformed(data.id)
     console.log(this.id)}
     if(this.id==='airConfigNull'){
      this.id=null
     }
     // for(let i=0 ;i <data.length; i++){ this.email +=data[i]; }
      
      
    
        });

    this.sourceCodelist()
    this.Carrierlist()
    this.fareList({page: this.pagestr.number, size: this.pagestr.size,})
   
    this.fareRegFg=this.fb.group({
      "applyTo":this.fb.group({
        "airType":["",[Validators.required]],
        "allow":['',[Validators.required]],
        "source":["",[Validators.required]],
        "carrier":["",[Validators.required]],
        "priority": ['',[Validators.required]],
        "classTypes":[""],
        "status":["A"],
        "fareType":["REFUNDABLE"],
        "fareBasisRegex":[""],
        "flightRegex":[""],
        "productClass":[""],
        "privateFareCodeRegex":[""],
        "sourceGroups":[''],
        "hideResult":[''],
        "fareMapping":['']
    }),
    "changeTo":this.fb.group({ 
      'baggageWeight':[''],
      'refundIndicator':[''],
      'freeMealIndicator':[''],
      'fetchFromAPI':[''],
      'fareFamily':[''],
    }),
    
    "rule":this.fb.group({
        "changeRuleTxt":[""],
        "cancellationRuleTxt":[""],
        "noShowRuleTxt":[""],
        "baggageRuleTxt":[""],
        "mealRuleTxt":[""],
        "seatRuleTxt":[""]
    })




      
     
  
    });
  

  }
  pagestr:any={
    number:'0',
    size:'10'
  }

  searchSource(){
    this.fareList({page: this.pagestr.number, size: this.pagestr.size,})

  }
  nextPage(event:PageEvent) {
    
    let page:any = {};
    page['page'] = event.pageIndex.toString();
    page['size'] = event.pageSize.toString();
    this.fareList(page)

  }
  closePopup(){
this.addfare.boolean=false
this.blankDetail()
  }
  onSubmit(){
    // console.log(this.fareRegFg.value);
this.AddFareConfig()
  }
  Carrierlist(){

    this.AirManagementService
    .carrierlist()
    .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.carrierList=data
       

        } else {
        
        } 
      },error : (err) => {

      }
    }
  )
  }

  sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}


AddFareConfig() {
  this.fareRegFg.value.rule.cancellationRuleTxt=JSON.stringify({schedule:this.scheduleData})
  this.fareRegFg.value.rule.changeRuleTxt=JSON.stringify({schedule:this.changeRule})
if(this.id){
  this.fareRegFg.value.userId=this.id

}
  
         this.disabled=true
         this.AirConfigService.saveFareRule(this.fareRegFg.value,this.addfare.id)
           .subscribe({
             next : (res) => {
              this.disabled=false

               if(res.status==200 || res.status==201) {
                if(this.addfare?.action==='newFare'){
                  this.toastMsgService.setMsg({msg : " Fare Rule Added Successfully!",msgTitle : "Success", msgType : "I"});

                }else{
                  this.toastMsgService.setMsg({msg : " Fare Rule Updated Successfully!",msgTitle : "Success", msgType : "I"});
                }
                 this.addfare.boolean=false
                 this.blankDetail()

                 this.fareList({page: this.pagestr.number, size: this.pagestr.size,})
               } else {
                 const body : any = res.body;
                 this.registerSourceErrorMsg(res.status,body?.result);
               } 
     
             },error : (err) => {
              this.disabled=false

               this.registerSourceErrorMsg(err.status,err.error);
             }
           }
         )
       }
     
       registerSourceErrorMsg(status : number,msg : string) {
         if(status >=500) {
          if(this.addfare?.action==='newFare'){

           this.toastMsgService.setMsg({msg : "Failed to Save Fare Rule",msgTitle : "Warning", msgType : "W"});
          }
           else{
            this.toastMsgService.setMsg({msg : "Failed to Update Fare Rule",msgTitle : "Warning", msgType : "W"})
           }
         } else {
          if(this.addfare?.action==='newFare'){

            this.toastMsgService.setMsg({msg : "Failed to Save Fare Rule",msgTitle : "Warning", msgType : "W"});}
            else{
             this.toastMsgService.setMsg({msg : "Failed to Update Fare Rule",msgTitle : "Warning", msgType : "W"})
            }
         } 
       }


       fareeList:any=[]
       fareList(page:any){
       
         this.AirConfigService
         .fareRulelist(this.searchText,page,this.id)
         .subscribe({
           next : (res:any) => {
             if(res) {
            let data=res.content
            this.fareeList=data

            if(data.length>0){
              this.pagestr.number=res['number']
              this.pagestr.size=res['size']
            }
            this.totalElements = res['totalElements'];

             } else {
             
             } 
           },error : (err) => {
       
           }
         }
       )
       }
       onlyNumberKey(event:any) {
     
        let charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
      }

      blankDetail(){
        this.fareRegFg=this.fb.group({
          "applyTo":this.fb.group({
            "airType":["",[Validators.required]],
            "allow":[''],
            "source":["",[Validators.required]],
            "carrier":["",[Validators.required]],
            "priority": ['',[Validators.required]],
            "classTypes":[""],
            "status":["A"],
            "fareType":["REFUNDABLE"],
            "fareBasisRegex":[""],
            "flightRegex":[""],
            "productClass":[""],
            "privateFareCodeRegex":[""],
            "sourceGroups":[''],
            "hideResult":[''],
            "fareMapping":['']
        }),
        "changeTo":this.fb.group({ 
          'baggageWeight':[''],
          'refundIndicator':[false],
          'freeMealIndicator':[true],
          'fetchFromAPI':[''],
          'fareFamily':[''],
        }),
        
        "rule":this.fb.group({
            "changeRuleTxt":[""],
            "cancellationRuleTxt":[""],
            "noShowRuleTxt":[""],
            "baggageRuleTxt":[""],
            "mealRuleTxt":[""],
            "seatRuleTxt":[""]
        })
    
    
    
    
          
         
      
        });
      }

      rowClick(element:any){
        this.getfarelist(element?.carrier)

        this.addfare.action='updateFare'
        this.fareRegFg=this.fb.group({
          "uuid":[element?.uuid],
          "applyTo":this.fb.group({
            "airType":[element?.travelType,[Validators.required]],
            "allow":[element?.allow],
            "source":[element?.source,[Validators.required]],
            "carrier":[element?.carrier,[Validators.required]],
            "priority": [element?.priority?.toString(),[Validators.required]],
            "classTypes":[element?.classTypes],
            "status":[element?.status],
            "fareType":[element?.fareType],
            "fareBasisRegex":[element?.fareBasisRegex],
            "flightRegex":[element?.flightRegex],
            "productClass":[element?.productClass],
            "privateFareCodeRegex":[element?.privateFareCodeRegex],
            "sourceGroups":[element?.sourceGroups],
            "hideResult":[element?.hideResult],
            "fareMapping":[element?.fareMapping]
            
        }),
        "changeTo":this.fb.group({ 
          'baggageWeight':[element?.changeTo?.baggageWeight],
          'refundIndicator':[element?.changeTo?.refundIndicator?.toString()],
          'freeMealIndicator':[element?.changeTo?.freeMealIndicator?.toString()],
          'fetchFromAPI':[element?.changeTo?.fetchFromAPI?.toString()],
          'fareFamily':[element?.changeTo?.fareFamily],
        }),
        
        "rule":this.fb.group({
            "changeRuleTxt":[element?.config?.changeRuleTxt],
            "cancellationRuleTxt":[element?.config?.cancellationRuleTxt],
            "noShowRuleTxt":[element?.config?.noShowRuleTxt],
            "baggageRuleTxt":[element?.config?.baggageRuleTxt],
            "mealRuleTxt":[element?.config?.mealRuleTxt],
            "seatRuleTxt":[element?.config?.seatRuleTxt]
        })
    
        });

       this.scheduleData= this.convertjson(element?.config?.cancellationRuleTxt)
       this.changeRule=this.convertjson(element?.config?.changeRuleTxt)
        this.addfare.boolean=true

        if(this.changeRule.length>0){
          this.addChagerule=true
          }else{
            this.addChagerule=false
          
          }
          if(this.scheduleData.length>0){
            this.Cancelationrule=true
            }else{
              this.Cancelationrule=false
            
            }
      }
      filterCarrier(item:any){
        if(item){
          let carrier=this.carrierList.filter((itm:any)=>itm?.airlineDesignatorCode===item)
          // console.log(carrier)
          return carrier[0]?.carrierName
        }else{
          return item
        }
        
      }
      filterSource(item:any){
        if(item){
          let source=this.sourceCodeList.filter((itm:any)=>itm?.code===item)
          return source[0]?.title
        }else{
          return item
        }
        
      }
      onMenuClick(event: any) {
        event.preventDefault();
        event.stopPropagation();
        
      
      }
      changeRule:any=[]
      scheduleData:any = [];
    
      ageGroups:any = ['adult', 'child', 'infant'];
      addCancelation(){

let  scheduleData:any = {
    from: '0:h',
    to: '0:h',
    adult: {
      charges: [
        { type: 'airline', amount: 0, status: 'A', currency: 'INR', description: '' },
        { type: 'platform', amount: 0, status: 'A', currency: 'INR', description: '' }
      ]
    },
    child: {
      charges: [
        { type: 'airline', amount: 0, status: 'A', currency: 'INR', description: '' },
        { type: 'platform', amount: 0, status: 'A', currency: 'INR', description: '' }
      ]
    },
    infant: {
      charges: [
        { type: 'airline', amount: 0, status: 'A', currency: 'INR', description: '' },
        { type: 'platform', amount: 0, status: 'A', currency: 'INR', description: '' }
      ]
    }
  }

  this.scheduleData.push(scheduleData)
  // console.log(this.fareRegFg?.value?.rule?.cancellationRuleTxt)
  if(this.scheduleData.length>0){
    this.Cancelationrule=true
    }else{
      this.Cancelationrule=false
    
    }
  
      }

      addChangeRule(){

        let  changeRule:any = {
            from: '0:h',
            to: '0:h',
            adult: {
              charges: [
                { type: 'airline', amount: 0, status: 'A', currency: 'INR', description: '' },
                { type: 'platform', amount: 0, status: 'A', currency: 'INR', description: '' }
              ]
            },
            child: {
              charges: [
                { type: 'airline', amount: 0, status: 'A', currency: 'INR', description: '' },
                { type: 'platform', amount: 0, status: 'A', currency: 'INR', description: '' }
              ]
            },
            infant: {
              charges: [
                { type: 'airline', amount: 0, status: 'A', currency: 'INR', description: '' },
                { type: 'platform', amount: 0, status: 'A', currency: 'INR', description: '' }
              ]
            }
          }
        
          this.changeRule.push(changeRule)
        
          if(this.changeRule.length>0){
            this.addChagerule=true
            }else{
              this.addChagerule=false
            
            }
              }


      convertjson(item:any){
        if(item){
         return JSON.parse(item).schedule
       
       }else{
         return []
        }
       }
addChagerule:boolean=false
Cancelationrule:boolean=false

       clearChangeRule(){
        this.addChagerule=false
      
        if(this.changeRule.length>0){
          this.addChagerule=true
          }else{
            this.addChagerule=false
          
          }
        this.changeRule.splice(this.changeRule.length-1, 1);
      
      }
      clearCancelation(){
        this.Cancelationrule=false
      
        if(this.scheduleData.length>0){
          this.Cancelationrule=true
          }else{
            this.Cancelationrule=false
          
          }
        this.scheduleData.splice(this.scheduleData.length-1, 1);
      
      }

      
      
farelist:any=[]
getfarelist(item:any){
  this.AirManagementService
  .getCarrierFareList(item.value||item)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.farelist=data
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
}
